module.exports = __webpack_public_path__ + "d85b270d.svg";